import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setupMediaFallback } from './shared/api';

setupMediaFallback();

(function setupServiceWorker() {
  if ('serviceWorker' in navigator) {
    // Migracion UNICA del service worker legacy de Workbox (evita invalidar el SW
    // en cada carga, lo que expira las suscripciones push).
    const migrated = localStorage.getItem('agorax_sw_migrated');
    if (!migrated) {
      try {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          registrations.forEach((r) => {
            const url = r.active ? r.active.scriptURL : '';
            if (url && url.includes('service-worker.js')) {
              r.unregister();
            }
          });
          localStorage.setItem('agorax_sw_migrated', '1');
        });
      } catch (e) {
        /* noop */
      }
    }
    // Registrar el service worker minimo (paso-through, sin cache) requerido por TWA.
    if (process.env.NODE_ENV === 'production') {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(() => {});
      });
    }
  }
})();

// La deteccion automatica de nuevas versiones (poll a /version.json + recarga
// forzada) fue removida: recargaba la pagina sin aviso y perdia el estado de
// pantallas de trabajo largo (inventario, cierre de caja). Las actualizaciones
// se aplican al recargar manualmente.

const rootEl = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootEl);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
